export default __webpack_public_path__ + "0cdc04701dd0712b5a75a471dff90804.png";